import React from "react";
import "../styles/UpgradePlans.css";

export default function UpgradePlanSelector({
  plans = [],
  selectedPlanId,
  onSelect,
  salePhase = "off",
  countdownLabel = null,
  className = "",
}) {
  const banner =
    salePhase === "active"
      ? countdownLabel
        ? `Black Friday Lifetime Deal ends in ${countdownLabel}`
        : "Black Friday Lifetime Deal is live"
      : salePhase === "upcoming" && countdownLabel
      ? `Black Friday Lifetime Deal opens in ${countdownLabel}`
      : null;

  return (
    <div className={`upgrade-plan-selector ${className}`}>
      {banner && <div className="upgrade-plan-banner">{banner}</div>}
      <div className="upgrade-plan-grid">
        {plans.map((plan) => {
          const isSelected = plan.id === selectedPlanId;
          return (
            <label
              key={plan.id}
              className={`upgrade-plan-card ${isSelected ? "selected" : ""}`}
              style={{ borderColor: isSelected ? plan.accent : undefined }}
            >
              <input
                type="radio"
                name="upgradePlan"
                value={plan.id}
                checked={isSelected}
                onChange={() => onSelect?.(plan.id)}
              />
              <div className="upgrade-plan-card__badge" style={{ color: plan.accent }}>
                {plan.badge}
              </div>
              <div className="upgrade-plan-card__title">{plan.label || plan.name}</div>
              <div className="upgrade-plan-card__price">{plan.price}</div>
              {plan.description && (
                <p className="upgrade-plan-card__description">{plan.description}</p>
              )}
              <ul className="upgrade-plan-card__features">
                {plan.keyPoints?.map((point) => (
                  <li key={point}>{point}</li>
                ))}
              </ul>
            </label>
          );
        })}
      </div>
    </div>
  );
}
